import { Injectable } from '@angular/core';
import { Marked } from 'marked';

@Injectable()
export class MarkdownRenderer {

  constructor() {
  }

  async render(content: string): Promise<string> {
    const markdownService = new Marked();

    return markdownService.parse(content);
  }
}
